interface action {
    type: string,
    payload: Array<any>,
}

const homeReceiptsReducer = (state = [], action: action) => {
    switch(action.type) {
        case 'SET_HOME_RECEIPTS':
            return action.payload;
        default:
            return state;
    }
}

export default homeReceiptsReducer;